module.exports = __webpack_public_path__ + "86c2a4aef36e9059746036699e4bce4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-kakuninnsimasu.png
// module id = 2071
// module chunks = 4